import * as helper from '@/common/helper'

// Birthdates are plain dates ('YYYY-MM-DD'). new Date('YYYY-MM-DD') parses as UTC midnight,
// which is the previous day anywhere west of UTC, so always build them as local noon.
export function toDateOnly(input) {
  if (!input) return null;
  if (typeof input === 'string') {
    const [y, m, d] = input.slice(0, 10).split('-').map(Number);
    return new Date(y, m - 1, d, 12, 0, 0, 0);
  }
  const dt = new Date(input);
  return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 12, 0, 0, 0);
}

export function toIsoDateString(dateLike) {
  const d = toDateOnly(dateLike);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

// Age in whole years today for a birthdate, or null when there is none
export function ageInYears(dob) {
  const d = toDateOnly(dob);
  if (!d) return null;
  const today = new Date();
  let age = today.getFullYear() - d.getFullYear();
  const m = today.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age--;
  return age;
}

// Returns a new date with the given parts replaced, clamping the day to the month's length
export function withDateParts(dateLike, { year, month, day } = {}) {
  const cur = toDateOnly(dateLike) || toDateOnly(new Date());
  const y = year !== undefined ? year : cur.getFullYear();
  const m = month !== undefined ? month : cur.getMonth();
  const d = Math.min(day !== undefined ? day : cur.getDate(), helper.daysInMonth(m + 1, y));
  return new Date(y, m, d, 12, 0, 0, 0);
}
